module.exports = __webpack_public_path__ + "static/media/biomas-brasil.c30ac550.jpeg";